import axios from "axios";
import utils from "@/utils/";
import { getItem } from "@/utils/storage";
import versions from "@/utils/init.js";
import router from "@/router";

const { singleToast } = utils;

const instance = axios.create({
  timeout: 20000, // 请求超时
});

// 请求拦截设置
instance.interceptors.request.use(
  (config) =>
    new Promise((resolve) => {
      const token = getItem("token") || "";
      const channel_code = getItem("channel_code") || "";
      if (token) config.headers["Authorization"] = token;
      config.headers["channelcode"] = channel_code || "default";
      config.headers["appversion"] = " 0.0.1";
      config.headers["ostype"] = versions.ios ? 2 : 1;

      resolve(config);
    })
);
// axios response封装的数据在data里面
instance.interceptors.response.use(
  (response) => {
    if (response.data.code === 401 || response.data.code === "401") {
      singleToast(response.data.msg || "登录失效,请重新登录");

      setTimeout(() => {
        router.push({
          name: "regist",
        });
      }, 1500);
      return Promise.reject(response.data);
    } else if (response.config && response.config.notCheckCode) {
      return response.data;
    } else if (
      // 请求成功
      response.data.code === 1 ||
      response.data.code === 200 ||
      response.data.code === "200"
    ) {
      return response.data;
    } else {
      singleToast(response.data.msg || "服务器开小差啦，请稍后再试");
      return Promise.reject(response.data);
    }
  },
  (error) => {
    const response = error.response || {};
    const config = error.config || {};

    if (axios.isCancel(error)) {
      return false;
    }
    if (!config.disableErrorTips) {
      // 统一报错处理
      if (response.data && response.data.errors && response.data.errors[0]) {
        singleToast(response.data.errors[0].msg);
      } else if (response.data && response.data.msg) {
        singleToast(response.data.msg);
      } else {
        singleToast("服务器开小差啦，请稍后再试");
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
